module.exports = __webpack_public_path__ + "static/media/icon-trial-account-expired.5d3d7635.png";